import { mixin as clickaway } from 'vue-clickaway'
import { KeycloakService } from '../../services/keycloak.service'

export default {
    name: 'TabBar',
    mixins: [ clickaway ],

    data() {
        return {
            tabsClass: 'tab-bars-hidden'
        }
    },

    props: {
        selected: String,
        settings: Boolean,
        createBooking: Boolean,
        editBooking: Boolean
    },

    computed: {
        isSuperUser() {
            return KeycloakService.isSuperUser()
        },

        isWarehouseManager() {
            return KeycloakService.isWarehouseManager()
        },

        isBookingAgent() {
            return KeycloakService.isBookingAgent()
        },
    },

    methods: {
        containsTarget(target) {
            return this.tab.includes(target)
        },

        selectTab(target) {
            return this.selected == target ? 'tab-bar-tab-selected' : ''
        },

        hideTabs() {
            this.tabsClass = 'tab-bars-hidden'
        },

        showTabs() {
            this.tabsClass = ''
        }
    }
}
